import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  selected_app: ''
};

export const selectedPortalApp = createSlice({
  name: 'selectedPortalApp',
  initialState,
  reducers: {
    setSelectedPortalApp: (state, action: PayloadAction<any>) => {
      state.selected_app = action.payload;
    }
  }
});

export const { setSelectedPortalApp } = selectedPortalApp.actions;
